import { Dropdown } from "@lockerpm/design";
import { DotsVertical } from "@untitled-ui/icons-react";
import { ReactNode } from "react";
import { DropdownRenderV2 } from "../antdHelpers/DropdownRender";

export interface ActionItem<T> {
  key: string;
  label: ReactNode;
  action: (data: T) => void;
}

interface ITableActionButtonV2Props<T> {
  data: T;
  actionList: ActionItem<T>[];
}

export const TableActionButtonV2 = <T,>({
  data,
  actionList,
}: ITableActionButtonV2Props<T>) => {
  // --------------- METHODS ---------------

  const onClickActionItems = (key: string, data: T) => {
    const findAction = actionList.find((item) => item.key === key);
    if (findAction) {
      findAction.action(data);
    }
  };

  // --------------- RENDER ---------------

  if (actionList.length === 0) return null;

  return (
    <Dropdown
      menu={{
        items: actionList.map((action) => ({
          key: action.key,
          label: action.label,
        })),
        onClick: ({ key, domEvent }) => {
          domEvent.preventDefault();
          domEvent.stopPropagation();
          onClickActionItems(key, data);
        },
      }}
      trigger={["click"]}
      dropdownRender={(menu) => <DropdownRenderV2>{menu}</DropdownRenderV2>}
    >
      <button
        className="h-11 w-11 min-w-11 flex items-center justify-center text-gray-v2-400 border rounded-lg border-transparent outline outline-offset-2 outline-transparent
      transition-all focus:text-brand-v2 focus:bg-white focus:border-brand-v2-300 focus:outline-brand-v2-400"
      >
        <DotsVertical className="h-5 w-5 min-w-5" />
      </button>
    </Dropdown>
  );
};
